"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParentFiltersList = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var ParentFiltersListItem_1 = require("./ParentFiltersListItem");
var model_1 = require("../../../../../../model");
exports.ParentFiltersList = function (props) {
    var parents = props.parents, currentFilterLocalId = props.currentFilterLocalId, setParents = props.setParents, onConnectingAttributeChanged = props.onConnectingAttributeChanged, connectingAttributes = props.connectingAttributes, attributes = props.attributes;
    var isDependentFiltersEnabled = model_1.useDashboardSelector(model_1.selectSupportsElementsQueryParentFiltering);
    if (!isDependentFiltersEnabled || parents.length < 1) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "gd-infinite-list" }, parents.map(function (item, index) {
        return (react_1.default.createElement(ParentFiltersListItem_1.ParentFiltersListItem, { key: item.localIdentifier, currentFilterLocalId: currentFilterLocalId, item: item, onClick: setParents, onConnectingAttributeSelect: onConnectingAttributeChanged, connectingAttributes: connectingAttributes[index], title: attributes[index].title }));
    })));
};
//# sourceMappingURL=ParentFiltersList.js.map